import React from "react";
import Header from "./components/Header";
import Banner from "./components/Banner";
import Services from "./components/Services";
import Menus from "./components/Menus";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";
import WhatsappFloat from "./components/WhatsappFloat";
import ContactUs from "./components/ContactUs";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import ReviewSection from "./components/Review";
import AboutUs from "./components/AboutUs";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800, // Animation duration (ms)
      once: true,    // Whether animation should happen only once
    });
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    const defaultLeak = { r: 212, g: 175, b: 55 };

    const setLeak = (rgb) => {
      root.style.setProperty("--leak-r", String(rgb.r));
      root.style.setProperty("--leak-g", String(rgb.g));
      root.style.setProperty("--leak-b", String(rgb.b));
    };

    const parseLeak = (value) => {
      const parts = String(value)
        .split(",")
        .map((s) => Number(s.trim()));
      if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return null;
      return { r: parts[0], g: parts[1], b: parts[2] };
    };

    const leakTargets = Array.from(document.querySelectorAll("[data-leak]"));
    if (leakTargets.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => (b.intersectionRatio ?? 0) - (a.intersectionRatio ?? 0));

        const top = visible[0];
        const leak = top?.target?.getAttribute("data-leak");
        const parsed = leak ? parseLeak(leak) : null;
        setLeak(parsed || defaultLeak);
      },
      {
        threshold: [0, 0.15, 0.3, 0.5, 0.7],
        rootMargin: "-10% 0px -35% 0px",
      }
    );

    leakTargets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="main-wrapper">
      <Header />
      <Banner />
      <Services />
      <Menus />
      <Gallery />
      <ReviewSection />
      <AboutUs />
      <Footer />
      <WhatsappFloat />
    </div>
  );
}

export default App;
